import { useState } from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { playAsGuest } from "src/store/auth"
import { apiErrorLines } from "src/utils/apiErrors"

import "./PlayAsGuestButton.css"

/* "Play as guest" (owner, 2026-10-02), under the sign-in and register forms. One press makes an
   account with a funny name and signs in to it; the profile offers to save it later. A refusal (the
   server's per-address throttle, mostly) is printed here rather than as a toast. */
const PlayAsGuestButton = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [busy, setBusy] = useState(false)
  const [errors, setErrors] = useState(null)

  const play = () => {
    setBusy(true)
    setErrors(null)
    dispatch(playAsGuest())
      .unwrap()
      .then(() => ModalService.hideAll())
      .catch((error) => {
        setErrors(error)
        setBusy(false)
      })
  }

  return (
    <div className="play-as-guest">
      <button type="button" className="quiet" onClick={play} disabled={busy}>
        {t("auth.playAsGuest")}
      </button>
      {apiErrorLines(errors).map(({ key, text }) => (
        <p key={key} className="errored-text">
          {text}
        </p>
      ))}
    </div>
  )
}

export default PlayAsGuestButton
